// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kndugGqH{display:flex;flex-direction:column;flex-grow:1;position:relative}.lbjPCPcn{word-wrap:break-word;font-size:1.13rem;font-weight:500;-webkit-hyphens:auto;hyphens:auto;margin-bottom:.5em}.h-T2Fw5t{margin-left:auto}._00RU0AbW,.h-T2Fw5t{align-items:center;display:flex}._00RU0AbW{flex-grow:1;justify-content:center}.IX7nYduC{--card-width:100%}.IX7nYduC>:not(:last-child){margin-bottom:var(--spacing-sm)}@media(min-width:667.98px){.IX7nYduC{--card-width:180px;grid-gap:var(--spacing-sm);display:grid;grid-template-columns:repeat(auto-fill,minmax(180px,1fr));grid-template-columns:repeat(auto-fill,minmax(var(--card-width),1fr));padding:0 var(--spacing-sm)}.IX7nYduC>:not(:last-child){margin-bottom:0}}@media(min-width:947.98px){.IX7nYduC{--card-width:200px;grid-gap:var(--spacing-lg);padding:0 var(--spacing-md)}}@media(min-width:1229.98px){.IX7nYduC{--card-width:246px;padding:0}}.pBRQ9PHf{margin-bottom:var(--spacing-xl);padding:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"list": "kndugGqH",
	"listTitle": "lbjPCPcn",
	"listFilters": "h-T2Fw5t",
	"listEmpty": "_00RU0AbW",
	"listGrid": "IX7nYduC",
	"listGroup": "pBRQ9PHf"
};
module.exports = ___CSS_LOADER_EXPORT___;
